import { Component, OnInit, ViewChild } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { FadvModalComponent } from '@fa-switch-sharedservices/ng-elements';
import { AccountService, AlertService, } from '@app/_services';
@Component({
  selector: 'app-credentialing',
  templateUrl: './credentialing.component.html',
  styleUrls: ['./credentialing.component.css']
})
export class LoginCredentialingComponent implements OnInit {

  loading = false;

  @ViewChild('credentialingalertmodal') credentialingalertmodal!: FadvModalComponent;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private accountService: AccountService,
    private alertService: AlertService,
  ) { }


  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
  }

  nextStep(): void {
    // default to home page
    const returnUrl = '/home/dashboard';
    this.router.navigateByUrl(returnUrl);
  }

}
